import { Card, CardActionArea, CardActions, CardContent, Collapse, IconButton, Tooltip} from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';

const StyledCard = styled(Card)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'flex-start',
  color: theme.palette.secondary.main,
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
  minHeight: 150,
  [theme.breakpoints.down('md')]: {
      minHeight: 200,
    },
}));

const StyledCardActionAreaSmall = styled(CardActionArea)(({ theme }) => ({
  minHeight: 124,
  [theme.breakpoints.down('md')]: {
      minHeight: 174,
    },
}));

const StyledCardActionArea = styled(CardActionArea)(({ theme }) => ({
  minHeight: 184,
  [theme.breakpoints.down('md')]: {
      minHeight: 234,
    },
}));


const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
        color: theme.palette.secondary.main,
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
        color: theme.palette.secondary.main,
      },
    },
  ],
}));

export const GridEntry = ({cardContent, cardActions, expandContent, useSmall = true, onExpand = null})  =>
{
    const theme = useTheme();

    const [expanded, setExpanded] = useState(false);

    const expand = () => {
      if(expanded === false && onExpand != null) {
        onExpand();
      }
      setExpanded(!expanded);
    };


    const renderCardActionArea = () => {
      if(useSmall) {
        return (
          <StyledCardActionAreaSmall>
              <CardContent sx={{position: 'absolute', top:'0px'}}>
                  {cardContent}
              </CardContent>
          </StyledCardActionAreaSmall>);
      }
      return (
          <StyledCardActionArea>
              <CardContent sx={{position: 'absolute', top:'0px'}}>
                  {cardContent}
              </CardContent>
          </StyledCardActionArea>);
    };


    return(
         <Grid bgcolor={'primary'} size={{ xs: 12,  md: 6, lg: 4, xl: 3 }}>
            <StyledCard className="custom-grid" theme={theme}>
                {renderCardActionArea()}
                <CardActions disableSpacing>
                        {cardActions}
                        {!!expandContent && <ExpandMore
                            expand={expanded}
                            onClick={() => expand()}
                            aria-expanded={expanded}
                            aria-label="show more"
                        >
                        <Tooltip title={(expanded? 'weniger': 'mehr') + ' anzeigen'}>
                            <ExpandMoreIcon />
                        </Tooltip>
                    </ExpandMore>}
                </CardActions>
                {!!expandContent && <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        {expandContent}
                    </CardContent>
                </Collapse>}
            </StyledCard>
        </Grid>
    );
};